import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { RpStandSchema, TRpStandFormData } from './schema'

export const useRpStandForm = () => {
  return useForm<TRpStandFormData>({
    resolver: zodResolver(RpStandSchema),
    defaultValues: {
      name: '',
      stream: '',
    },
  })
}
